import React, { MouseEventHandler } from 'react';

import Link from 'next/link';

import { ConsumptionPageTypes } from 'src/types/consumption';
import { globalUrlHelper } from 'src/utils/common';

import * as customStyled from './styles';
export enum CastType {
  ACTOR = 'actor',
  DIRECTOR = 'director'
}

export interface Crew {
  castType: CastType;
  reelName: string;
  realName: string;
  link?: string;
  textColor?: string;
}

interface ContentCrewProps extends ConsumptionPageTypes.CommonUIProps {
  crew: Crew[];
}

const navigateCrew =
  (link: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.location.href = link;
  };

const prefixText = (item: Crew) => (
  <span css={customStyled.prefixText(!!item.link, item.textColor)}>
    {item.realName}
  </span>
);

const suffixText = (item: Crew) => (
  <span css={customStyled.suffixText}>{`${
    item.castType !== CastType.DIRECTOR ? 'as' : ''
  } ${item.reelName}`}</span>
);

const ContentCrew: React.FC<ContentCrewProps> = ({ crew, spaceX, spaceY }) => {
  const renderCrew = () => {
    return crew.map((item: Crew, index) => {
      return item.link ? (
        <div
          css={customStyled.textWrapper}
          key={index}
          data-testid={`ContentSufix-${index}`}>
          <a
            key={item.link} // Use a stable and unique identifier as the key
            onClick={navigateCrew(globalUrlHelper(item.link))}
            href={globalUrlHelper(item.link)}>
            {prefixText(item)}{' '}
          </a>
          {suffixText(item)}
        </div>
      ) : (
        <div
          css={customStyled.textWrapper}
          key={index}
          data-testid={`ContentPrefix-${index}`}>
          {prefixText(item)} {suffixText(item)}
        </div>
      );
    });
  };

  return (
    <div
      data-testid="crew-container"
      css={customStyled.crewWrapper(spaceY as string)}>
      {renderCrew()}
    </div>
  );
};

export default ContentCrew;
